<template>
  <div>
    <a-card size="small" title="处理器配置">
        <a-button slot="extra" type="primary" @click="handleNew">新增</a-button>
        <a-button slot="extra" type="primary" style="margin-left:20px;" @click="handleRefresh">刷新配置</a-button>


        <a-form layout="inline" :form="form" class="myform" @keyup.enter.native="handleSubmit">
            <a-form-item label="所属领域">
                <a-select v-model="searchP.domain" style="width: 80px">
                    <a-select-option value="001">前台</a-select-option>
                    <a-select-option value="002">中台</a-select-option>
                    <a-select-option value="003">开放</a-select-option>
                    <a-select-option value="004">基础</a-select-option>
                </a-select>
            </a-form-item>

            <a-form-item label="关键字">
                <a-input v-model="searchP.keyword" placeholder="关键字" allow-clear ></a-input>
            </a-form-item>

            <a-form-item>
                <a-button type="primary" @click="handleSubmit">查询</a-button>
            </a-form-item>
        </a-form>

        <tableE ref="cpuTableID" :platForms="platforms"></tableE>

        <a-modal title="刷新配置" :visible="isShow" :confirm-loading="confirmLoading" width="300px"
            @cancel="handleCancel">
            <label for="">选择领域：</label>
            <a-select v-model="domain" style="width: 80px">
                <a-select-option value="001">前台</a-select-option>
                <a-select-option value="002">中台</a-select-option>
                <a-select-option value="003">开放</a-select-option>
                <a-select-option value="004">基础</a-select-option>
            </a-select>

            <template slot="footer">
                <a-button key="back" @click="handleCancel">
                    取消
                </a-button>
                <a-button key="submit" type="primary" :loading="confirmLoading" @click="handleOk">
                    刷新
                </a-button>
            </template>
        </a-modal>
    </a-card>

     
  </div>
</template>
<script>

import tableE from './table'
export default {
    data() {
        return {
            form: this.$form.createForm(this),
            searchP:{
                domain:'001',
                keyword:''
            },
            platforms:[],
            isShow:false,
            confirmLoading:false,
            domain:'001',
        };
    },
    methods: {
        handleSubmit(){
            this.$refs.cpuTableID.handleSearch(this.searchP);
        },
        handleNew(){
            this.$router.push({
                path: "add_processorClass",
                query: {
                    domain:this.searchP.domain,
                    classname:'',
                }
            });
        },
        handleRefresh(){
            this.isShow = true;
        },
        handleCancel(){
            this.isShow = false;
        },
        handleOk(){
            console.log(this.domain)
            let that = this;
            that.$store.dispatch({
                type: "servicekey/processorRefreshClass",
                params: {domain: that.domain}
            }).then((res) => {
                if (res.status == '200') {
                    that.message.success('刷新成功')
                    that.isShow = false;
                }
            });
        }
    },
    components:{
        tableE
    },
    mounted(){
        const { query } = this.$route;
        if(query.domain){
            this.searchP.domain = query.domain
        }
        this.handleSubmit()
    }
};
</script>
<style scoped>

</style>
